import { ReactNode } from 'react';
import { ToastOptions } from 'react-toastify';
import { FileDto, FileStorageControllerService, FileType } from 'data';

export const download = (blob: Blob, name: string, type?: string) => {
  const href = window.URL.createObjectURL(new Blob([blob], type ? { type } : {}));
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', `${name}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadFileFromCollection = async (
  file: FileDto,
  fileType: FileType,
  onFileFetchFn: () => void,
  showInfoMessage: (
    message: ReactNode,
    options?: ToastOptions<object> | undefined,
    onOpen?: (() => void) | undefined,
  ) => void,
) => {
  onFileFetchFn();

  await FileStorageControllerService.getFile(file.name as string, fileType)
    .then((res) => {
      return res;
    })
    .then((blob) => download(blob, file.name as string))
    .catch((err) => Promise.reject(new Error(err)))
    .finally(() => onFileFetchFn());

  showInfoMessage(`Download started: ${file.name}`);
};
